<div class="main-container">
  <app-header *ngIf="this.globals.isUserLoggedIn"></app-header>
  <app-login *ngIf="!this.globals.isUserLoggedIn"></app-login>
  <app-application-list *ngIf="this.globals.isUserLoggedIn && !this.globals.isCreateApplication"></app-application-list>
  <app-application-form *ngIf="this.globals.isUserLoggedIn && this.globals.isCreateApplication"></app-application-form>
</div>

